import routes from '../routes/index.routes';
import { BidderDomainsStates } from '../../pages/bidder-domains-states/index/bidder-domains-states.page';

export const BidderDomainsStatesRouter = [
	{
		path: routes.bidderDomainsStates.index(),
		element: <BidderDomainsStates />,
	},
];
